import React from "react";

import moment from "moment";

import { formatDayMonth, useTranslation } from "utils";

import { Card, Icon, Trans } from "components";

const getColor = (completed, daysToDeadline) => {
  if (completed) {
    return "green";
  }

  if (daysToDeadline < 0) {
    return "red";
  }

  if (daysToDeadline < 4) {
    return "orange";
  }

  return "";
};

export const TaskCard = ({ documentName, year, deadline, completed, onClick, dataTestId }) => {
  const { t } = useTranslation("tasks");

  const daysToDeadline = moment(deadline).diff(moment(), "days", true);
  const isLate = daysToDeadline < 0;

  return (
    <Card
      className={`task-card ${completed ? "completed" : ""} ${onClick ? "pointer" : ""}`}
      onClick={onClick}
      mixpanelText="task-card"
      dataTestId={dataTestId}
    >
      {daysToDeadline < 4 && !completed && (
        <div className={`warning-header ${getColor(completed, daysToDeadline)}`}>
          <Icon iconName={`${isLate ? "tabler/alert-triangle" : "tabler/clock"}`} className="icon inline" />

          <span className="paragraph-s">
            {isLate
              ? t("taskCard.late")
              : t("taskCard.daysLeft", {
                  days: Math.floor(daysToDeadline),
                })}
          </span>
        </div>
      )}

      <div className="content">
        <div>
          <Icon iconName={completed ? "tabler/circle-check-filled" : "tabler/file-upload"} size="m" className="margin-right-50" />
        </div>

        <p>
          {/* Use Trans to use b tag in translation without using dangerouslySetInnerHtml */}
          <Trans i18nKey="tasks:taskCard.description">
            <b>{{ name: documentName }}</b>
            <b>{{ year }}</b>
          </Trans>
        </p>
        <span className={`date ${getColor(completed, daysToDeadline)}`}>{completed ? t("taskCard.completed") : formatDayMonth(deadline)}</span>
      </div>
    </Card>
  );
};
